import { render, staticRenderFns } from "./QuickCommend.vue?vue&type=template&id=36fe8bb0&scoped=true"
import script from "./QuickCommend.vue?vue&type=script&lang=js"
export * from "./QuickCommend.vue?vue&type=script&lang=js"
import style0 from "./QuickCommend.vue?vue&type=style&index=0&id=36fe8bb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fe8bb0",
  null
  
)

export default component.exports